/**
 * "just now", "5m ago", "3d ago", then a date.
 *
 * Lifted out of `NotificationBell`, which had it privately, when the sessions
 * list needed the same thing. Two copies would drift, and the drift would be
 * visible: the same instant reading "3d ago" in the bell and "3 days ago" on
 * the profile makes the product look assembled rather than designed.
 *
 * Past a week it becomes a plain date. "23d ago" is arithmetic the reader has
 * to do; "12 Jul" is the thing they were going to work out anyway.
 */
export function relativeTime(iso: string | Date): string {
  const then = iso instanceof Date ? iso : new Date(iso);
  const ms = Date.now() - then.getTime();

  /**
   * A clock that is a little behind the server's reads as a future date, and
   * `Math.floor` of a negative gap counts DOWN — "-1m ago". Anything not yet
   * a minute old, in either direction, is "just now".
   */
  const minutes = Math.floor(ms / 60_000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;

  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;

  return then.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
}
